import { CheckBox as PixiCheckBox } from "@pixi/ui";
import { IDestroyOptions } from "pixi.js";

export class CheckBox extends PixiCheckBox {
    public override destroy(options?: boolean | IDestroyOptions): void {
        this.onChange.disconnectAll();
        this.innerView.removeAllListeners('pointerdown');
        this.innerView.removeAllListeners('pointerup');
        this.innerView.removeAllListeners('pointerupoutside');
        this.innerView.removeAllListeners('pointerout');
        this.innerView.removeAllListeners('pointertap');
        this.innerView.removeAllListeners('pointerover');
        super.destroy(options);
    }
}
